import type { Dispatch, SetStateAction } from "react";
import type { Message } from "../types.ts";

/** BE が社内スレッド追記と一緒に返す API レスポンスの共通契約 */
export type HasThreadMessage = {
  thread_message?: Message | null;
};

/** API 応答と WS ライブ追記が同時に来ても message.id で1件にまとめる。
 * 先着が visibility 欠落だと「社内メモ」誤表示になるため、後着で欠けたフィールドを補完する。
 */
export function appendMessageUnique(prev: Message[], incoming: Message): Message[] {
  const id = Number(incoming.id);
  if (!Number.isFinite(id)) return [...prev, incoming];
  const idx = prev.findIndex((m) => Number(m.id) === id);
  if (idx < 0) return [...prev, incoming];
  const existing = prev[idx];
  const merged: Message = {
    ...existing,
    ...incoming,
    // 空で上書きしない（WS→POST の順でも visibility を保つ）
    visibility: incoming.visibility ?? existing.visibility,
    source: incoming.source || existing.source,
    author: incoming.author || existing.author,
    message: incoming.message || existing.message,
    created_at: incoming.created_at || existing.created_at,
  };
  if (
    merged.visibility === existing.visibility &&
    merged.source === existing.source &&
    merged.author === existing.author &&
    merged.message === existing.message &&
    merged.created_at === existing.created_at
  ) {
    return prev;
  }
  const next = prev.slice();
  next[idx] = merged;
  return next;
}

/** BE の thread_message をタイムライン state へ即反映（標準パターン） */
export function applyThreadMessageToTimeline(
  setMessages: Dispatch<SetStateAction<Message[]>>,
  result: HasThreadMessage | null | undefined,
): void {
  if (result?.thread_message) {
    setMessages((prev) => appendMessageUnique(prev, result.thread_message!));
  }
}
